/*-----------------------------------------------------------------
- Comments From
-----------------------------------------------------------------*/
export default {
    message: {
        success: 'Mesajınız başarıyla gönderildi.',
        error  : 'Kayıt Sorunu',
    },
};
